import React, {useEffect, useState} from 'react';
import {logPageLoadEvents} from '@ibibo/analytics';
import {useSelector, useDispatch} from 'react-redux';
import {
  userDataSelector,
  prevPageNameSelector,
  mpnfoSelector,
  tokenSelector,
  userCountrySelector,
} from '../../store/selectors';
import {termsPageRequest} from '../../store/actions';
import Agreement from '../../stories/components/OnboardingNew/GccComponents/Agreement/Agreement';

import {updatePreviousPageName} from '../../store/actions';
import OnboardingNew from '../../stories/components/OnboardingNew/OnboardingNew';
import SelectAgreement from './containers/SelectAgreement/SelectAgreement';
import Terms from './containers/Terms';
import {selectAgrDemoData1} from './containers/SelectAgreement/data';

const TermsConditions = () => {
  const userInfo = useSelector(userDataSelector);
  const {email, mobile, requestIp, accountId} = userInfo;
  const data = useSelector(prevPageNameSelector);
  const mpnfoValue = useSelector(mpnfoSelector);
  const token = useSelector(tokenSelector);
  const timeZone = useSelector(userCountrySelector);
  const {prevPageName} = data;
  const dispatch = useDispatch();

  const [stepIndex, setStepIndex] = useState(1);
  const [agreementType, setAgreementType] = useState('');
  const handleSubmit = (value, agreement_type) => {
    setStepIndex(value);
    setAgreementType(agreement_type);
  };

  useEffect(() => {
    const events = {
      eVar34: email,
      eVar35: mobile,
      eVar23: prevPageName,
      eVar28: requestIp,
      eVar67: accountId,
      eVar24: 'onboarding|mypartner',
      eVar37: 'domain_sbu:india|domain_country:in|domain_currency:inr|domain_language:eng',
      eVar107: `mpnfo_${mpnfoValue}`,
    };

    logPageLoadEvents('onboarding:tnc', events);
    dispatch(updatePreviousPageName('onboarding:tnc'));
  }, [dispatch]);

  return (
    <OnboardingNew step={3}>
      {!timeZone && <Terms agreementType={agreementType} />}
      {timeZone && <Agreement />}
    </OnboardingNew>
  );
};

export default TermsConditions;
